/*
----------------------------
Module - search-filters
----------------------------
*/

import $ from 'jquery';
/*global fmg*/

(function(){
    'use strict';

    fmg.searchFiltersModal = function(){

        function refresh() {
            
            if (fmg.vars.screensize > 1) {

                if (typeof modal_dialog != "undefined") {
                    modal_dialog.close();
                }

            }
            
        }

        function setupToggleFiltersButton() {
            
            $("body").on("click", ".search-filters__toggle-btn", function(event) {

                // Not using event.target because the clicked element target might be the svg in the button
                var $this = $(this);

                var form_id = '#' + $this.parent().find('form').prop('id');
                
                $.magnificPopup.open({
    
                    showCloseBtn: false,
                    alignTop: true,
    
                    items: {
                        src: form_id,
                        type: 'inline'
                    }
    
                });

                // Store current instance of popup into variable
                modal_dialog = $.magnificPopup.instance;
                    
            });
            
        }

        function setupFiltersDoneButton() {
            
            $("body").on("click", ".search-filters-form__done-btn", function() {

                if (typeof modal_dialog != "undefined") {
                    modal_dialog.close();
                }
                
            });

        }

        function init() {
            
            if ($(".search-results").length) {
                setupToggleFiltersButton();
                setupFiltersDoneButton();
            }

        }
        
        var modal_dialog;
        
        return {
            init: init,
            refresh: refresh
        };

    }()

    document.addEventListener("DOMContentLoaded", function () {
        fmg.searchFiltersModal.init();
    });

}());

(function(){
    'use strict';

    fmg.searchFiltering = function(){

        var generateResults = fmg.fn.debounce(function () {

            // Prepare to make a call to funnelback for new results
            // We are adding each field's query string and joining them up later with &
            var new_requested_query_string_array = [];

            // Get selected categories in the form of a query string
            if ($search_category_filter.length) {

                var selected_categories_query_string = $search_category_filter.serialize();

                if (selected_categories_query_string.length) {
                    new_requested_query_string_array.push(selected_categories_query_string);
                }

            }

            // Make a copy of the basic search url endpoint
            var new_requested_search_endpoint = base_search_endpoint;

            var new_requested_query_string = new_requested_query_string_array.join("&") + "&query=" + current_query;
            
            if (new_requested_query_string.length) {

                // Convert array into a string, joined by &, concatenate with source URL
                new_requested_search_endpoint = new_requested_search_endpoint + "&" + new_requested_query_string;
                
            }

            // Only ajax results if the next requested search is not the same as the previous one
            if (last_requested_search_endpoint !== new_requested_search_endpoint) {

                // When results are returned, we want to take specfic parts and replace the following
                // - Selected category filter info
                // - Results summary count
                // - Main results 
                // - Pagination

                $.get( new_requested_search_endpoint, function( data ) {

                    // Selected category filter info
                    var $new_selected_categories = $(data).find(search_selected_categories_wrapper_class);

                    if ($new_selected_categories.length) {
                        $search_selected_categories_wrapper.html($new_selected_categories.html());
                    }

                    // Results summary
                    var $new_results_summary = $(data).find(search_results_summary_wrapper_class);

                    if ($new_results_summary.length) {
                        $search_results_summary_wrapper.html($new_results_summary.html());
                    }
                    
                    // Main results
                    var $new_results_listing = $(data).find(search_results_listing_wrapper_class);

                    if ($new_results_listing.length) {
                        $search_results_listing_wrapper.html($new_results_listing.html());
                    }

                    // Pagination
                    var $new_pagination = $(data).find(search_pagination_wrapper_class);

                    if ($new_pagination.length) {
                        $search_pagination_wrapper.html($new_pagination.html());
                    }

                     // Update URL without reload so that users can press back to last filtered view
                     // First store just the pure URL without query string
                     var history_url = window.location.href.split('?')[0];

                     if (new_requested_query_string.length) {
                        history_url += "?" + new_requested_query_string;
                     }

                     window.history.replaceState("", "", history_url);
                    
                });

                // Remember the last request
                last_requested_search_endpoint = new_requested_search_endpoint;

            }

        }, 700);

        function setupSearchCategoryFilter() {

            $search_category_filter = $("#search-filters-form input");

            // Enable the radios which are disabled by default so that users can't click on it until its initialised
            $search_category_filter.prop("disabled", false);

            $search_category_filter.on("change", function(event) {

                var $this_filter = $(event.target);

                $search_category_filter.not($this_filter).prop("checked",false);

                generateResults();

            });

        }

        function init() {

            $search_results_wrapper = $(".search-results");
            $search_filters_form = $("#search-filters-form");

            if ($search_results_wrapper.length && $search_filters_form.length) {

                base_search_endpoint = $search_results_wrapper.data("search-endpoint");
                current_query = fmg.fn.sanitizeString(fmg.fn.getQueryParameter("query"));
                
                $search_selected_categories_wrapper = $(search_selected_categories_wrapper_class);
                $search_results_summary_wrapper = $(search_results_summary_wrapper_class);
                $search_results_listing_wrapper = $(search_results_listing_wrapper_class);
                $search_pagination_wrapper = $(search_pagination_wrapper_class);

                if (base_search_endpoint.length) {

                    // Only if .search-results__inner exists and theres a data-search-url then these filters can activate
                    setupSearchCategoryFilter();

                }
                
            }
            
        }

        var $search_results_wrapper;
        var base_search_endpoint;
        var last_requested_search_endpoint;
        var current_query;
        
        var $search_filters_form;
        var $search_category_filter;
        
        var $search_selected_categories_wrapper;
        var search_selected_categories_wrapper_class = ".search-results__selected-category";
        var $search_results_summary_wrapper;
        var search_results_summary_wrapper_class = ".search-results__summary";

        var $search_results_listing_wrapper;
        var search_results_listing_wrapper_class = ".search-results__listing-wrapper";
        var $search_pagination_wrapper;
        var search_pagination_wrapper_class = ".search-results__pagination-wrapper";
        
        return {
            init: init
        };

    }();

    document.addEventListener("DOMContentLoaded", function () {
        fmg.searchFiltering.init();
    });

}());
